import Hero from "@/containers/framerlanding/Hero";
import About from "@/containers/framerlanding/About";
import StudentReviews from "./StudentReviews";
import { WhyWisWizStory, WhyWisWizFeatures } from "./WhyWisWiz";
import WaveSections from "@/containers/layout/WaveSections";

import { useAppContext } from "@/context/AppContext";
import { useLandingContext } from "@/context/LandingContext";
import { useEffect, useRef } from "react";
import { useSearchParams } from "next/navigation";
import posthog from "posthog-js";

export default function Landing() {
  const { sectionRefs, setActiveSection, scrollToSection } =
    useLandingContext();
  const lastTrackedSection = useRef<string>("hero");
  const searchParams = useSearchParams();

  const { isMobile } = useAppContext();

  useEffect(() => {
    setActiveSection(0);
  }, []);

  // Handle scrollTo query parameter
  useEffect(() => {
    const scrollTo = searchParams.get("scrollTo");
    if (scrollTo) {
      setTimeout(() => {
        const sectionMap: Record<string, { ref: any; id: number }> = {
          whyWisWiz: { ref: sectionRefs.whyWisWizRef, id: 1 }
        };

        const section = sectionMap[scrollTo];
        if (section) {
          scrollToSection(section.ref, section.id);
        }
      }, 100);
    }
  }, [searchParams, sectionRefs, scrollToSection]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      const sections = [
        { ref: sectionRefs.heroRef, navId: 0, name: "hero" },
        { ref: sectionRefs.whyWisWizRef, navId: 1, name: "why-wiswiz" },
        { ref: sectionRefs.aboutUsSectionRef, navId: 0, name: "about" }
      ];

      let currentNavId = 0;
      let currentName = "hero";
      for (const section of sections) {
        if (
          section.ref.current &&
          section.ref.current.offsetTop <= currentScrollY + 200
        ) {
          currentNavId = section.navId;
          currentName = section.name;
        }
      }

      setActiveSection(currentNavId);

      if (currentName !== lastTrackedSection.current) {
        lastTrackedSection.current = currentName;
        posthog.capture("$pageview", {
          $current_url: `${window.origin}/#${currentName}`
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [setActiveSection, sectionRefs]);

  // isMobile starts as `null` on mount; AppContext sets it once the first
  // resize handler runs (a few ms later). Wait for it so we don't briefly
  // render a desktop tree to mobile.
  if (isMobile === null) return null;

  return (
    <WaveSections
      sections={[
        { content: <Hero />, ref: sectionRefs.heroRef },
        { content: <StudentReviews /> },
        { content: <WhyWisWizStory />, ref: sectionRefs.whyWisWizRef },
        { content: <WhyWisWizFeatures /> },
        { content: <About />, ref: sectionRefs.aboutUsSectionRef }
      ]}
    />
  );
}
